/**
 * SAVENE — Product Card interactions
 * - Swatch click: variant switch (imagem/preço/estoque/URL) sem reload
 * - Quick-add: AJAX /cart/add; se tem variante de tamanho, abre modal
 * - Loading / error / success states
 */
(function () {
  'use strict';

  const CART_ADD = (window.routes && window.routes.cart_add_url) || '/cart/add';
  const CART_DRAWER_ID = 'sv-dr';

  // Money formatter (simple — Shopify theme usa Brazilian format R$ 1.234,56)
  function formatMoney(cents) {
    const v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + v;
  }

  function showError(card, msg) {
    const err = card.querySelector('[data-sv-err]');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
    clearTimeout(err._t);
    err._t = setTimeout(() => { err.hidden = true; }, 4000);
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = true;
      const sp = btn.querySelector('[data-sv-qa-spinner]');
      if (sp) sp.hidden = false;
    } else {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
      btn.disabled = false;
      const sp = btn.querySelector('[data-sv-qa-spinner]');
      if (sp) sp.hidden = true;
    }
  }

  // ============================================================
  // SWATCH CLICK — variant switch
  // ============================================================
  function bindSwatches(card) {
    const btns = card.querySelectorAll('[data-sv-sw-btn]');
    if (!btns.length) return;
    btns.forEach((b) => {
      b.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const available = b.dataset.available === '1';
        if (!available) return;
        if (b.classList.contains('is-current')) return;

        const variantId = b.dataset.variantId;
        const image = b.dataset.image;
        const price = parseInt(b.dataset.price, 10);
        const compare = parseInt(b.dataset.compare, 10);

        // 1) Update swatch state
        btns.forEach((x) => {
          x.classList.remove('is-current');
          x.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('is-current');
        b.setAttribute('aria-pressed', 'true');

        // 2) Update image (fade)
        if (image) {
          const img = card.querySelector('[data-sv-card-img-primary]');
          if (img && img.src !== image) {
            img.style.transition = 'opacity 0.2s';
            img.style.opacity = '0.3';
            setTimeout(() => {
              img.src = image;
              img.onload = () => { img.style.opacity = '1'; };
            }, 150);
          }
        }

        // 3) Update price
        if (!isNaN(price)) {
          const priceEl = card.querySelector('[data-sv-price]');
          if (priceEl) priceEl.textContent = formatMoney(price);

          const compareEl = card.querySelector('[data-sv-price-compare]');
          if (!isNaN(compare) && compare > price) {
            if (compareEl) compareEl.textContent = formatMoney(compare);
          } else if (compareEl) {
            compareEl.remove();
          }

          // Parcelamento
          const inst = card.querySelector('[data-sv-installment]');
          if (price >= 9000) {
            const per = Math.floor(price / 3);
            if (inst) {
              inst.textContent = '3x de ' + formatMoney(per) + ' sem juros';
              inst.hidden = false;
            }
          } else if (inst) {
            inst.hidden = true;
          }
        }

        // 4) Update URL on the image link and card
        const link = card.querySelector('[data-sv-card-img-link]');
        const baseUrl = card.dataset.productUrl;
        if (link && baseUrl) {
          link.href = baseUrl + '?variant=' + variantId;
        }
        const nameLink = card.querySelector('.pc2__name a');
        if (nameLink && baseUrl) {
          nameLink.href = baseUrl + '?variant=' + variantId;
        }

        // 5) Update quick-add variant id
        const qa = card.querySelector('[data-sv-qa]');
        if (qa) qa.dataset.variantId = variantId;
      });
    });
  }

  // ============================================================
  // QUICK-ADD CLICK
  // ============================================================
  function bindQuickAdd(card) {
    const btn = card.querySelector('[data-sv-qa]');
    if (!btn) return;

    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      const hasSize = btn.dataset.hasSize === '1';
      const variantId = btn.dataset.variantId;
      const handle = btn.dataset.productHandle;

      // Se tem variante de tamanho → abre modal
      if (hasSize && window.svOpenQuickAdd) {
        window.svOpenQuickAdd(handle, btn);
        return;
      }

      if (!variantId) {
        showError(card, 'Produto indispon\u00edvel. Tente de novo.');
        return;
      }

      setLoading(btn, true);

      try {
        const res = await fetch(CART_ADD + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (!res.ok) {
          let msg = 'N\u00e3o conseguimos adicionar. Tente novamente.';
          try {
            const data = await res.json();
            if (data.description) msg = data.description;
            else if (data.message) msg = data.message;
          } catch (_) {}
          throw new Error(msg);
        }

        const cartData = await res.json();

        // Notify cart-drawer to refresh and open
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sv-product-card',
            productVariantId: variantId,
            cartData: cartData
          });
        } else {
          // Fallback: abrir drawer direto se existir
          const drawer = document.getElementById(CART_DRAWER_ID);
          if (drawer) {
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            // Atualiza counter
            fetch('/cart.js').then(r => r.json()).then(c => {
              const badge = document.querySelector('.hdr__badge');
              if (badge) badge.textContent = c.item_count;
            }).catch(() => {});
          }
        }
      } catch (err) {
        showError(card, err.message || 'Erro inesperado. Fale com a gente pelo WhatsApp.');
      } finally {
        setLoading(btn, false);
      }
    });
  }

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    document.querySelectorAll('[data-sv-card]').forEach((card) => {
      if (card.dataset.svInit === '1') return;
      card.dataset.svInit = '1';
      bindSwatches(card);
      bindQuickAdd(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind in case of dynamically loaded cards (search results, load more, etc.)
  window.svInitProductCards = init;
})();
